import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

function Video({ time, onSeek}) {
  const ref = useRef();
//  const [isPlaying, setIsPlaying] = useState(true)
  useEffect(() => {
    if (ref.current && time !== undefined && time !== null) {
        ref.current.currentTime = time;
    }
  }, [time]);
  return (
    <video data-test = 'sceneExtractVideoComponent'
      id="source-video"
      src="/video/pdf-demo-video/20180418_1548_18626_FR_H264-original.mp4"
      onError={(e) => {e.target.src = '/video/movie.mp4'}}
      width="100%"
      height="100%"
      ref={ref}
      onSeeked={onSeek}
    />
  );
}
Video.propTypes={
time:PropTypes.string,
onSeek:PropTypes.string,
}
Video.defaultProps= {
time:[],
onSeek:[],
}
// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }
export default React.memo(Video);
